import { useState, useEffect } from 'react';
import firebase from 'firebase/compat/app';
import { useDocumentData as useFirebaseHooksDocumentData } from 'react-firebase-hooks/firestore';

export const useDocumentData = <T>(
    documentRef:
        | firebase.firestore.DocumentReference<T>
        | firebase.firestore.Query<T>,
    disabled?: boolean
): T | undefined => {
    const [data, setData] = useState<T>();

    const [collectedData] = useFirebaseHooksDocumentData<T>(
        !disabled ? (documentRef as never) : undefined
    );

    useEffect(() => {
        if (!disabled) setData(collectedData);
    }, [collectedData]);

    return data;
};
